/**
 * Lone Sport — hover card quick-add AJAX
 * Uses capture phase to intercept before data-instant link navigation.
 */
document.addEventListener('click', async function lsQuickAdd(e) {
  const btn = e.target.closest('.lone-hover-size-btn');
  if (!btn) return;

  // Stop link from navigating
  e.preventDefault();
  e.stopPropagation();

  if (btn.classList.contains('is-adding') || btn.disabled || btn.classList.contains('is-soldout')) return;

  const variantId = parseInt(btn.dataset.variantId, 10);
  if (!variantId) return;

  btn.classList.add('is-adding');

  try {
    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    });

    if (!addRes.ok) throw new Error('add-failed');

    btn.classList.remove('is-adding');
    btn.classList.add('is-added');

    // Update cart count badge
    const cartRes = await fetch('/cart.js');
    if (cartRes.ok) {
      const cart = await cartRes.json();
      document.querySelectorAll('cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.classList.toggle('opacity-0', cart.item_count === 0);
      });

      // Dispatch refresh so cart drawer updates its contents
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      // Open cart drawer
      const trigger = document.querySelector('[aria-controls="cart-drawer"]');
      if (trigger) trigger.click();
    }

    setTimeout(() => btn.classList.remove('is-added'), 2000);

  } catch (_) {
    btn.classList.remove('is-adding');
    // Fallback: navigate to PDP
    const link = btn.closest('product-card')?.querySelector('a.lone-pc-card-entire');
    if (link) window.location.href = link.href;
  }
}, true); // capture phase
